import { Pipe, PipeTransform } from '@angular/core';
import { TipoAtividade } from 'app/interfaces/enum/tipo-atividade.enum';


@Pipe({
  name: 'nomeAtividade'
})
export class NomeAtividadePipe implements PipeTransform {
  transform(value: TipoAtividade) {
    switch (value) {
      case TipoAtividade.REUNIAO_ONLINE: return 'REUNIÃO ONLINE';
      case TipoAtividade.REUNIAO_PRESENCIAL: return 'REUNIÃO PRESENCIAL';
      case TipoAtividade.APROVACAO_DESPESA: return 'APROVAÇÃO DESPESA';
      case TipoAtividade.APROVACAO_REQUISITO: return 'APROVAÇÃO REQUISITO';
      default: return value.toString();
    }
  }
}